<script>
  export default {
    name: "ItemSelected",
    props: {
      item: {
        type: Object,
        required: true,
      },
      onClose: {
        type: Function,
        default: null,
      },
    },
    computed: {
      hasClose() {
        return typeof this.onClose === "function" || this._events.close;
      },
    },
    methods: {
      handleClose() {
        this.$emit("close", this.item);
        if (typeof this.onClose === "function") this.onClose(this.item);
      },
    },
  };
</script>

<template>
  <div class="itemSelected">
    <p>{{ item && item.name }}</p>

    <button v-if="hasClose" class="itemSelected__xMarkIcon" type="button" aria-label="Quitar" title="Quitar" @click.stop="handleClose">
      <iconic name="close" />
    </button>
  </div>
</template>

<style lang="scss" scoped>
  .itemSelected {
    @include Flex(row, space-between, center);
    padding: 2px 10px;
    gap: 5px;
    font-size: 14px;
    border-radius: 50px;
    color: #242424;
    background: #fff;

    &__xMarkIcon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      padding: 0;
      border: none;
      background: transparent;
      cursor: pointer;
      color: #242424;
      font-size: 10px;
    }
  }
</style>
